module.exports = __webpack_public_path__ + "img/dhl_logo.3b1c959c.png";